export const ROOT_CATEGORY_TAB = { label: 'All', value: 'all' }

export const BLOG_ARTICLES_PER_PAGE = {
  regular: 9,
  featured: 4,
  relevant: 3
} as const

export const BLOG_SORTING_PARAMS = {
  byFeatured: 'featured_first'
} as const

export const IMAGE_PRIORITY_INDEX = [0, 1, 2, 3, 4, 5]
